define('components/AdSlot',[
    "jquery",
    "logging",
    "utilities",
    "ads"
], function ($, logging, utilities, ads) {
    var _ModuleName = "Ad Slot";

    /*
        config: {
            id,                 // string       : DIV ID of Ad Slot
            position,           // string       : Position Value (eg. DT_ATF_TOP)
            sizes,              // string       : Eligable Sizes (eg. 300x250)
            yieldbot,           // bool         : Whethor or not slot is eligable for Yieldbot
            outofpage,          // bool         : Whether or not slot is out of page
            mobile              // bool         : Whether or not slot is mobile
            }
    */

    function AdSlot(scope, config) {
        "use strict";

        var $ad = $(scope);

        ;

        config.dom = $ad;
        config.loaded = false;
        var result = ads.registerAdSlot(config);

        if(result) {
            ;
        } else {
            ;
        }

        return {
            slotId: config.id
        }
    }

    /**
     * Initialize component JavaScript
     * @param {*} args 
     */
    return {
        init: function init(args) {
            // Do not initialize the module if we are on a mobile device
            if ((utilities.IsPhone() !== args.Config.mobile)) {
                ;
                $(args.scope).remove();
                return null;
            }

            ;
            return new AdSlot(args.scope, args.Config);
        }
    }
});


